"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.object.entries.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.string.replace-all.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _interopRequireWildcard2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _configuration = require("@/api/configuration");
var _customer = require("@/api/customer");
var _order = require("@/api/order");
var _enum = require("@/utils/enum");
var _validate = require("@/utils/validate");
var _lodash = require("lodash");
var _moment = _interopRequireDefault(require("moment"));
var _vuePropertyDecorator = require("vue-property-decorator");
var _AddPickupAddressModal = _interopRequireDefault(require("./AddPickupAddressModal.vue"));
var _CustomerOrderForm = _interopRequireDefault(require("./CustomerOrderForm.vue"));
var _ModifyHistoryModal = _interopRequireDefault(require("./ModifyHistoryModal.vue"));
var _OrderInfoForm = _interopRequireDefault(require("./OrderInfoForm.vue"));
var _PackageOrderForm = _interopRequireDefault(require("./PackageOrderForm.vue"));
var _PaymentOrderForm = _interopRequireDefault(require("./PaymentOrderForm.vue"));
var _PrintInformationForm = _interopRequireDefault(require("./PrintInformationForm.vue"));
var _ProductOrderForm = _interopRequireDefault(require("./ProductOrderForm.vue"));
var _ReceiptPrint = _interopRequireDefault(require("./ReceiptPrint.vue"));
var _order2 = require("@/types/order");
var _shopeeOrder = require("@/api/shopeeOrder.api");
var _shopifyOrder = require("@/api/shopifyOrder.api");
var OrderModal = /*#__PURE__*/function (_Vue) {
  function OrderModal() {
    var _this;
    (0, _classCallCheck2.default)(this, OrderModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, OrderModal, [].concat(args));
    (0, _defineProperty2.default)(_this, "disabled", void 0);
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "visible", false);
    (0, _defineProperty2.default)(_this, "form", {
      products: []
    });
    (0, _defineProperty2.default)(_this, "status", "create");
    (0, _defineProperty2.default)(_this, "orderStatus", "");
    (0, _defineProperty2.default)(_this, "loading", false);
    (0, _defineProperty2.default)(_this, "orderProgress", {});
    (0, _defineProperty2.default)(_this, "type", _order2.OrderType.Order);
    (0, _defineProperty2.default)(_this, "createdAt", 0);
    (0, _defineProperty2.default)(_this, "configVAT", {});
    (0, _defineProperty2.default)(_this, "compareOrder", {});
    (0, _defineProperty2.default)(_this, "OrderType", _order2.OrderType);
    (0, _defineProperty2.default)(_this, "orderDetails", []);
    (0, _defineProperty2.default)(_this, "isLinkShopee", false);
    (0, _defineProperty2.default)(_this, "shopType", void 0);
    (0, _defineProperty2.default)(_this, "emailInput", "");
    (0, _defineProperty2.default)(_this, "addCustomerDialogVisible", false);
    (0, _defineProperty2.default)(_this, "customer", undefined);
    (0, _defineProperty2.default)(_this, "shopifyOrderId", undefined);
    return _this;
  }
  (0, _inherits2.default)(OrderModal, _Vue);
  return (0, _createClass2.default)(OrderModal, [{
    key: "handleCreateCustomer",
    value: function handleCreateCustomer() {
      console.log("customer ne", this.customer);
      this.addCustomerDialogVisible = false;
      this.$refs.customerModal.handleCreateFromShopifyOrder((0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.customer), {}, {
        phone: this.customer.phone,
        email: this.customer.email
      }), this.shopType);
    }
  }, {
    key: "checkCustomerMonthBirthday",
    get: function get() {
      if (!this.form.detailCustomer) {
        return false;
      }
      var birthdayMonth = (0, _moment.default)(this.form.detailCustomer.customer.birthday, "DD/MM/YYYY").format("MM");
      var currentMonth = (0, _moment.default)().format("MM");
      if (birthdayMonth == currentMonth) {
        return true;
      }
      return false;
    }
  }, {
    key: "user",
    get: function get() {
      return this.$store.state.user.info;
    }
  }, {
    key: "codeDelivery",
    get: function get() {
      if (this.form.codeGHTK == "" && this.form.codeGHN == "") {
        return false;
      }
      return this.form.codeGHTK || this.form.codeGHN;
    }
    // check chinh sua don duoi 2 thang
  }, {
    key: "checkPermissionEdit",
    get: function get() {
      var isPermission = this.$store.state.permission.routes.some(function (e) {
        return e.path == "/order/order-edit";
      });
      var current = (0, _moment.default)().diff((0, _moment.default)(this.createdAt), "months");
      return isPermission && current <= 2 || this.user.role.name == "Admin";
    }
    // get title modal theo status va theo type
  }, {
    key: "modalTitle",
    get: function get() {
      if (this.type == _order2.OrderType.Consign) {
        return this.status == "create" ? "New consign order" : "Update consign order";
      }
      return this.status == "create" ? "New order" : "Update order";
    }
  }, {
    key: "handleCheckRankCustomer",
    value: function () {
      var _handleCheckRankCustomer = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var route;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return");
            case 3:
              if (this.form.detailCustomer.currentRank) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return");
            case 5:
              if (!(this.form.detailCustomer.totalSale > this.form.detailCustomer.nextRank.amount && !(0, _lodash.isEqual)(this.form.detailCustomer.currentRank.id, this.form.detailCustomer.nextRank.id))) {
                _context.next = 14;
                break;
              }
              _context.prev = 6;
              _context.next = 9;
              return this.$confirm("This customer has qualified enough to upgrade rank. Do you want to upgrade?", "Warning", {
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                type: "warning"
              });
            case 9:
              route = this.$router.resolve({
                path: "/customer",
                query: {
                  customerId: this.form.detailCustomer.customer.id
                }
              });
              window.open(route.href, "_blank");
            case 11:
              _context.prev = 11;
              return _context.abrupt("return");
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[6,, 11, 14]]);
      }));
      function handleCheckRankCustomer() {
        return _handleCheckRankCustomer.apply(this, arguments);
      }
      return handleCheckRankCustomer;
    }()
  }, {
    key: "handleDelivery",
    value: function handleDelivery() {
      if (this.form.codeGHTK != "") {
        window.open("https://khachhang.giaohangtietkiem.vn/khachhang?code=".concat(this.form.codeGHTK), "_blank");
      } else if (this.form.codeGHN != "") {
        window.open("https://khachhang.ghn.vn/order/search/".concat(this.form.codeGHN, "/false"), "_blank");
      } else {
        this.$refs.pickupModal.handleUpdate(this.form);
      }
    }
  }, {
    key: "handlePrint",
    value: function handlePrint() {
      this.$refs.printReceipt.handlePrint();
    }
  }, {
    key: "handleModifyHistory",
    value: function handleModifyHistory() {
      this.$refs.ModifyHistoryModal.handleView(this.form);
    }
  }, {
    key: "handleDelete",
    value: function () {
      var _handleDelete = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.$confirm("Confirm delete order", "Warning", {
                cancelButtonText: "No",
                confirmButtonText: "Delete",
                type: "warning"
              });
            case 2:
              _context2.prev = 2;
              this.loading = true;
              _context2.next = 6;
              return _order.orderApi.delete(this.form.id);
            case 6:
              this.$emit("submit:ok");
              this.visible = false;
              this.$notify.success({
                title: "Delete order",
                message: "Successfully"
              });
            case 9:
              _context2.prev = 9;
              this.loading = false;
              return _context2.finish(9);
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[2,, 9, 12]]);
      }));
      function handleDelete() {
        return _handleDelete.apply(this, arguments);
      }
      return handleDelete;
    }()
  }, {
    key: "createData",
    value: function () {
      var _createData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var listProducts, form, data, res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return this.$refs.customer.$refs.form.validate();
            case 3:
              _context3.next = 5;
              return this.$refs.product.$refs.form.validate();
            case 5:
              _context3.next = 7;
              return this.$refs.package.$refs.form.validate();
            case 7:
              _context3.next = 9;
              return this.$refs.info.$refs.form.validate();
            case 9:
              _context3.next = 14;
              break;
            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](0);
              return _context3.abrupt("return", this.$message.error("Fill correct all input"));
            case 14:
              listProducts = this.form.products.filter(function (e) {
                return !!e.quantity;
              });
              console.log("listProducts ne", listProducts);
              if (!listProducts.some(function (el) {
                return el.quantity > el.productQuantity;
              })) {
                _context3.next = 18;
                break;
              }
              return _context3.abrupt("return", this.$message.error("The quantity entered must be less than the quantity of lot number"));
            case 18:
              if (listProducts.length) {
                _context3.next = 20;
                break;
              }
              return _context3.abrupt("return", this.$message.error("Products least 1 item!"));
            case 20:
              form = (0, _objectSpread2.default)({}, this.form);
              delete form.products;
              data = {
                order: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, form), {}, {
                  remindDate: form.remindDate && form.remindDate / 1000,
                  createdAt: form.createdAt / 1000,
                  vatFactor: form.vatFactor || this.configVAT.value,
                  shippingCharge: +form.shippingCharge
                }),
                addressCityId: form.addressCityId,
                addressDistrictId: form.addressDistrictId,
                addressWardId: form.addressWardId,
                details: listProducts.map(function (e) {
                  return {
                    isUseBirthdayDiscount: e.isUseBirthdayDiscount,
                    originPrice: e.originPrice,
                    retailPrice: e.retailPrice,
                    realPrice: e.realPrice,
                    discountAmount: e.discountAmount,
                    discountPercent: e.discountPercent,
                    quantity: e.quantity,
                    totalPrice: e.totalPrice,
                    profit: e.profit,
                    productId: e.id,
                    isPublished: e.isPublished,
                    lotNumber: e.lotNumber,
                    shippingCharge: +e.shippingCharge,
                    expired: e.expired,
                    dateOfManufacture: e.dateOfManufacture,
                    depositOrderDetailId: e.depositOrderDetailId,
                    shopifyOrderDetailId: e.shopifyOrderDetailId,
                    shopeeOrderDetailId: e.shopeeOrderDetailId
                  };
                }),
                customerId: this.form.customerId,
                staffId: this.form.staffId,
                progress: this.orderProgress,
                saleChannelId: this.form.saleChannelId,
                depositOrderId: this.form.depositOrderId,
                shopeeOrderId: this.form.shopeeOrderId,
                shopifyOrderId: this.form.shopifyOrderId,
                shopifyOrderDetailId: this.form.shopifyOrderDetailId
              };
              this.loading = true;
              // console.log("data ne", data);
              // console.log("type ne", this.type);
              _context3.prev = 24;
              res = null;
              console.log("type ne", this.type);
              console.log("data ne", data);
              if (!(this.type == _order2.OrderType.Order)) {
                _context3.next = 34;
                break;
              }
              _context3.next = 31;
              return _order.orderApi.create(data);
            case 31:
              res = _context3.sent;
              _context3.next = 43;
              break;
            case 34:
              if (!(this.type == _order2.OrderType.Consign)) {
                _context3.next = 40;
                break;
              }
              _context3.next = 37;
              return _order.orderApi.createConsign(data);
            case 37:
              res = _context3.sent;
              _context3.next = 43;
              break;
            case 40:
              _context3.next = 42;
              return _order.orderApi.createGift(data);
            case 42:
              res = _context3.sent;
            case 43:
              this.$notify.success({
                title: "New order",
                message: "Successfully"
              });
              this.$emit("submit:ok");
              this.visible = false;
              this.handleCheckRankCustomer();
            case 47:
              _context3.prev = 47;
              this.loading = false;
              return _context3.finish(47);
            case 50:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 11], [24,, 47, 50]]);
      }));
      function createData() {
        return _createData.apply(this, arguments);
      }
      return createData;
    }()
  }, {
    key: "updateData",
    value: function () {
      var _updateData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4() {
        var form;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.prev = 1;
              _context4.next = 4;
              return this.$refs.customer.$refs.form.validate();
            case 4:
              _context4.next = 6;
              return this.$refs.product.$refs.form.validate();
            case 6:
              _context4.next = 8;
              return this.$refs.info.$refs.form.validate();
            case 8:
              _context4.next = 13;
              break;
            case 10:
              _context4.prev = 10;
              _context4.t0 = _context4["catch"](1);
              return _context4.abrupt("return", this.$message.error("Fill correct all input"));
            case 13:
              if (this.form.products.length) {
                _context4.next = 15;
                break;
              }
              return _context4.abrupt("return", this.$message.error("Products least 1 item!"));
            case 15:
              this.loading = true;
              form = (0, _objectSpread2.default)({}, this.form);
              _context4.next = 19;
              return _order.orderApi.update(this.form.id, {
                order: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, form), {}, {
                  remindDate: form.remindDate && form.remindDate / 1000,
                  createdAt: form.createdAt / 1000,
                  vatFactor: form.vatFactor || this.configVAT.value
                }),
                addressCityId: this.form.addressCityId,
                addressDistrictId: this.form.addressDistrictId,
                addressWardId: this.form.addressWardId,
                customerId: this.form.customerId,
                staffId: this.form.staffId,
                saleChannelId: this.form.saleChannelId,
                shopeeOrderId: this.form.shopeeOrderId,
                shopifyOrderId: this.form.shopifyOrderId
              });
            case 19:
              _context4.next = 21;
              return this.updateDetail();
            case 21:
              _context4.next = 23;
              return this.updateOrderProgress();
            case 23:
              _context4.next = 25;
              return this.updateStatus();
            case 25:
              _context4.next = 27;
              return this.updateDateCreated();
            case 27:
              _context4.next = 29;
              return _order.orderApi.modify(this.form.id);
            case 29:
              this.visible = false;
              this.$notify({
                title: "Update order",
                message: "Successfully",
                type: "success"
              });
              this.$emit("submit:ok");
              this.handleCheckRankCustomer();
            case 33:
              _context4.prev = 33;
              this.loading = false;
              return _context4.finish(33);
            case 36:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[0,, 33, 36], [1, 10]]);
      }));
      function updateData() {
        return _updateData.apply(this, arguments);
      }
      return updateData;
    }()
  }, {
    key: "updateOrderProgress",
    value: function () {
      var _updateOrderProgress = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee5() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _order.orderApi.updateProgress(this.orderProgress.id, {
                orderProgress: this.orderProgress
              });
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function updateOrderProgress() {
        return _updateOrderProgress.apply(this, arguments);
      }
      return updateOrderProgress;
    }()
  }, {
    key: "updateStatus",
    value: function () {
      var _updateStatus = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee6() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _order.orderApi.updateStatus(this.form.id, {
                status: this.form.orderStatus
              });
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function updateStatus() {
        return _updateStatus.apply(this, arguments);
      }
      return updateStatus;
    }()
  }, {
    key: "updateDateCreated",
    value: function () {
      var _updateDateCreated = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee7() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if ((0, _lodash.isEqual)(this.form.createdAt, this.createdAt)) {
                _context7.next = 3;
                break;
              }
              _context7.next = 3;
              return _order.orderApi.updateCreatedAt(this.form.id, {
                createdAt: this.form.createdAt / 1000
              });
            case 3:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function updateDateCreated() {
        return _updateDateCreated.apply(this, arguments);
      }
      return updateDateCreated;
    }()
  }, {
    key: "updateDetail",
    value: function () {
      var _updateDetail = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee8() {
        var i, e, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              i = 0;
            case 1:
              if (!(i < this.form.products.length)) {
                _context8.next = 15;
                break;
              }
              e = this.form.products[i];
              data = {
                isUseBirthdayDiscount: e.isUseBirthdayDiscount,
                originPrice: e.originPrice,
                retailPrice: e.retailPrice,
                realPrice: e.realPrice,
                discountAmount: e.discountAmount,
                discountPercent: e.discountPercent,
                quantity: e.quantity,
                totalPrice: e.totalPrice,
                profit: e.profit,
                productId: e.id,
                isPublished: e.isPublished,
                lotNumber: e.lotNumber,
                shippingCharge: e.shippingCharge,
                expired: e.expired,
                dateOfManufacture: e.dateOfManufacture,
                depositOrderDetailId: e.depositOrderDetailId
              };
              if (e.detailId) {
                _context8.next = 8;
                break;
              }
              _order.orderApi.addDetail(this.form.id, {
                detail: data
              });
              _context8.next = 12;
              break;
            case 8:
              _context8.next = 10;
              return _order.orderApi.updateDetail(e.detailId, {
                orderDetail: data
              });
            case 10:
              _context8.next = 12;
              return _order.orderApi.updateDetailQuantity(e.detailId, {
                quantity: e.quantity
              });
            case 12:
              i++;
              _context8.next = 1;
              break;
            case 15:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function updateDetail() {
        return _updateDetail.apply(this, arguments);
      }
      return updateDetail;
    }()
  }, {
    key: "handleCreate",
    value: function handleCreate(type) {
      this.visible = true;
      this.status = "create";
      this.type = type;
      this.orderDetails = [];
      this.form = {
        products: [],
        customerId: this.type == _order2.OrderType.Gift ? 0 : undefined,
        shippingCharge: undefined,
        createdAt: (0, _moment.default)().valueOf()
      };
      this.fetchConfigVAT();
      this.orderStatus = "";
      this.orderProgress = {
        deliveryFeeType: _order2.DeliveryFeeType.NoPublish,
        shippingChargeBy: _order2.ShippingChargeBy.Customer
      };
    }
    // Xu ly lay chi tiet don shopee roi map với sản phẩm hiện có để tạo đơn
  }, {
    key: "fetchDetailShopeeOrder",
    value: function () {
      var _fetchDetailShopeeOrder = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee9(id) {
        var _this2 = this;
        var res, index, _loop, i, _res$data$shopeeOrder;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee9$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return _shopeeOrder.shopeeOrderApi.findOne(id);
            case 2:
              res = _context10.sent;
              this.orderProgress = {
                deliveryFeeType: _order2.DeliveryFeeType.NoPublish,
                shippingChargeBy: _order2.ShippingChargeBy.Customer
              };
              // console.log("res.data.shopeeOrderDetails", res.data.shopeeOrderDetails);
              index = 0;
              _loop = /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _loop() {
                var _element$shopeeProduc;
                var element;
                return (0, _regeneratorRuntime2.default)().wrap(function _loop$(_context9) {
                  while (1) switch (_context9.prev = _context9.next) {
                    case 0:
                      element = res.data.shopeeOrderDetails[i]; // if (element.orderDetails.length !== 0) continue;
                      if ((_element$shopeeProduc = element.shopeeProduct) !== null && _element$shopeeProduc !== void 0 && _element$shopeeProduc.products2) {
                        element.shopeeProduct.products2.forEach(function (product) {
                          _this2.orderDetails.push({
                            product: product,
                            id: product.id,
                            productGalleries: product.productGalleries,
                            name: product.name,
                            quantity: element.quantity,
                            totalPrice: 0,
                            commissionAmount: 0,
                            maxQuantity: undefined,
                            indexProduct: index,
                            shopeeOrderDetailId: element.id
                          });
                          index++;
                        });
                      }
                      // if (element.shopeeProduct?.product) {
                      //   const product = element.shopeeProduct.product;
                      //   this.orderDetails.push({
                      //     product: product,
                      //     id: product.id,
                      //     productGalleries: product.productGalleries,
                      //     name: product.name,
                      //     quantity: element.quantity,
                      //     totalPrice: 0,
                      //     commissionAmount: 0,
                      //     maxQuantity: undefined,
                      //     indexProduct: index,
                      //     shopeeOrderDetailId: element.id,
                      //   });
                      //   index++;
                      // }
                    case 2:
                    case "end":
                      return _context9.stop();
                  }
                }, _loop);
              });
              i = 0;
            case 7:
              if (!(i < ((_res$data$shopeeOrder = res.data.shopeeOrderDetails) === null || _res$data$shopeeOrder === void 0 ? void 0 : _res$data$shopeeOrder.length))) {
                _context10.next = 12;
                break;
              }
              return _context10.delegateYield(_loop(), "t0", 9);
            case 9:
              i++;
              _context10.next = 7;
              break;
            case 12:
              // console.log("res.data.shopeeOrderDetails", res.data.shopeeOrderDetails);
              this.form = {
                products: this.orderDetails,
                shippingCharge: 0,
                createdAt: (0, _moment.default)().valueOf(),
                shopeeOrderId: id
              };
            case 13:
            case "end":
              return _context10.stop();
          }
        }, _callee9, this);
      }));
      function fetchDetailShopeeOrder(_x) {
        return _fetchDetailShopeeOrder.apply(this, arguments);
      }
      return fetchDetailShopeeOrder;
    }() // Xử lý lấy thông tin đơn và khách hàng sau khi tạo customer
  }, {
    key: "handleFetchShopifyOrderAfterCreateCustomer",
    value: function () {
      var _handleFetchShopifyOrderAfterCreateCustomer = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee10() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee10$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return this.$refs.customer.fetchCustomers();
            case 2:
              _context11.next = 4;
              return this.fetchDetailShopifyOrder(this.shopifyOrderId);
            case 4:
            case "end":
              return _context11.stop();
          }
        }, _callee10, this);
      }));
      function handleFetchShopifyOrderAfterCreateCustomer() {
        return _handleFetchShopifyOrderAfterCreateCustomer.apply(this, arguments);
      }
      return handleFetchShopifyOrderAfterCreateCustomer;
    }() // Xu ly lay chi tiet don shopify roi map với sản phẩm hiện có để tạo đơn
  }, {
    key: "fetchDetailShopifyOrder",
    value: function () {
      var _fetchDetailShopifyOrder = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee11(id) {
        var _res$data$phone,
          _this3 = this;
        var res, index, _loop2, i;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee11$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              this.shopifyOrderId = id;
              _context13.next = 3;
              return _shopifyOrder.shopifyOrderApi.findOne(id);
            case 3:
              res = _context13.sent;
              this.orderProgress = {
                deliveryFeeType: _order2.DeliveryFeeType.NoPublish,
                shippingChargeBy: _order2.ShippingChargeBy.Customer
              };
              this.customer = {
                email: res.data.email == "No email provided" ? undefined : res.data.email,
                name: res.data.customerName,
                phone: res.data.phone == "No phone number" ? undefined : (_res$data$phone = res.data.phone) === null || _res$data$phone === void 0 ? void 0 : _res$data$phone.replace("+84", "0").replaceAll(" ", ""),
                address: res.data.shippingAddress
              };
              index = 0;
              console.log("first");
              _loop2 = /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _loop2() {
                var _element$giveawayDeta, _element$shopifyProdu;
                var element, products;
                return (0, _regeneratorRuntime2.default)().wrap(function _loop2$(_context12) {
                  while (1) switch (_context12.prev = _context12.next) {
                    case 0:
                      element = res.data.shopifyOrderDetails[i];
                      if (!(((_element$giveawayDeta = element.giveawayDetails) === null || _element$giveawayDeta === void 0 ? void 0 : _element$giveawayDeta.length) !== 0)) {
                        _context12.next = 3;
                        break;
                      }
                      return _context12.abrupt("return", 1);
                    case 3:
                      products = (_element$shopifyProdu = element.shopifyProduct) === null || _element$shopifyProdu === void 0 ? void 0 : _element$shopifyProdu.products2;
                      console.log("product ne", products);
                      if (products.length != 0) {
                        products.forEach(function (product) {
                          console.log("product ne", product);
                          _this3.orderDetails.push({
                            product: product,
                            id: product.id,
                            productGalleries: product.productGalleries,
                            name: product.name,
                            quantity: element.quantity,
                            totalPrice: 0,
                            commissionAmount: 0,
                            maxQuantity: undefined,
                            indexProduct: index,
                            shopifyOrderDetailId: element.id
                          });
                          index++;
                        });
                      }
                      // if (element.shopifyProduct?.product) {
                      //   const product = element.shopifyProduct.product;
                      //   this.orderDetails.push({
                      //     product: product,
                      //     id: product.id,
                      //     productGalleries: product.productGalleries,
                      //     name: product.name,
                      //     quantity: element.quantity,
                      //     totalPrice: 0,
                      //     commissionAmount: 0,
                      //     maxQuantity: undefined,
                      //     indexProduct: index,
                      //     shopifyOrderDetailId: element.id,
                      //   });
                      //   index++;
                      // }
                    case 6:
                    case "end":
                      return _context12.stop();
                  }
                }, _loop2);
              });
              i = 0;
            case 10:
              if (!(i < res.data.shopifyOrderDetails.length)) {
                _context13.next = 17;
                break;
              }
              return _context13.delegateYield(_loop2(), "t0", 12);
            case 12:
              if (!_context13.t0) {
                _context13.next = 14;
                break;
              }
              return _context13.abrupt("continue", 14);
            case 14:
              i++;
              _context13.next = 10;
              break;
            case 17:
              this.form = {
                products: this.orderDetails,
                shippingCharge: undefined,
                createdAt: (0, _moment.default)().valueOf(),
                shopifyOrderId: id
              };
              console.log("form ne", this.form);
              this.handleCheckExistCustomerByEmailAndPhone();
              // if (await this.handleCheckExistCustomerByPhone(res.data)) {
              //   console.log("check phone");
              //   return;
              // }
              // console.log("check email");
              // await this.handleCheckExistCustomerByEmail(res.data);
            case 20:
            case "end":
              return _context13.stop();
          }
        }, _callee11, this);
      }));
      function fetchDetailShopifyOrder(_x2) {
        return _fetchDetailShopifyOrder.apply(this, arguments);
      }
      return fetchDetailShopifyOrder;
    }()
  }, {
    key: "handleCheckExistCustomerByEmailAndPhone",
    value: function () {
      var _handleCheckExistCustomerByEmailAndPhone = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee12() {
        var phone, email, res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee12$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              phone = this.customer.phone;
              email = this.customer.email;
              if (!(phone || email)) {
                _context14.next = 7;
                break;
              }
              _context14.next = 5;
              return _customer.customerApi.findOneByEmailAndPhone({
                email: email,
                phone: phone
              });
            case 5:
              res = _context14.sent;
              if ((0, _lodash.isEmpty)(res.data)) {
                this.addCustomerDialogVisible = true;
              } else {
                this.$set(this.form, "customerId", res.data.id);
              }
            case 7:
            case "end":
              return _context14.stop();
          }
        }, _callee12, this);
      }));
      function handleCheckExistCustomerByEmailAndPhone() {
        return _handleCheckExistCustomerByEmailAndPhone.apply(this, arguments);
      }
      return handleCheckExistCustomerByEmailAndPhone;
    }()
  }, {
    key: "handleCheckExistCustomerByEmail",
    value: function () {
      var _handleCheckExistCustomerByEmail = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee13(orderShopify) {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee13$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              if (!(!orderShopify.email || orderShopify.email == "No email provided")) {
                _context15.next = 2;
                break;
              }
              return _context15.abrupt("return", false);
            case 2:
              _context15.next = 4;
              return _customer.customerApi.findOneByEmailAndPhone({
                email: orderShopify.email
              });
            case 4:
              res = _context15.sent;
              if (!(0, _lodash.isEmpty)(res.data)) {
                _context15.next = 10;
                break;
              }
              this.addCustomerDialogVisible = true;
              return _context15.abrupt("return", true);
            case 10:
              this.$set(this.form, "customerId", res.data.id);
              return _context15.abrupt("return", false);
            case 12:
            case "end":
              return _context15.stop();
          }
        }, _callee13, this);
      }));
      function handleCheckExistCustomerByEmail(_x3) {
        return _handleCheckExistCustomerByEmail.apply(this, arguments);
      }
      return handleCheckExistCustomerByEmail;
    }()
  }, {
    key: "handleCheckExistCustomerByPhone",
    value: function () {
      var _handleCheckExistCustomerByPhone = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee14(orderShopify) {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee14$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              console.log("order shopify ne", orderShopify);
              if (!(!orderShopify.phone || orderShopify.phone == "No phone number")) {
                _context16.next = 3;
                break;
              }
              return _context16.abrupt("return", false);
            case 3:
              _context16.next = 5;
              return _customer.customerApi.findOneByEmailAndPhone({
                phone: orderShopify.phone
              });
            case 5:
              res = _context16.sent;
              if (!(0, _lodash.isEmpty)(res.data)) {
                _context16.next = 11;
                break;
              }
              this.addCustomerDialogVisible = true;
              return _context16.abrupt("return", true);
            case 11:
              this.$set(this.form, "customerId", res.data.id);
              return _context16.abrupt("return", false);
            case 13:
            case "end":
              return _context16.stop();
          }
        }, _callee14, this);
      }));
      function handleCheckExistCustomerByPhone(_x4) {
        return _handleCheckExistCustomerByPhone.apply(this, arguments);
      }
      return handleCheckExistCustomerByPhone;
    }()
  }, {
    key: "handleLink",
    value: function handleLink(data, type) {
      this.orderDetails = [];
      this.isLinkShopee = true;
      this.fetchConfigVAT();
      if (type === "shopee") {
        this.fetchDetailShopeeOrder(data.id);
      } else {
        this.fetchDetailShopifyOrder(data.id);
      }
      this.orderStatus = "";
      this.visible = true;
      this.type = _order2.OrderType.Order;
      this.status = "create";
      this.shopType = type;
    }
  }, {
    key: "fetchConfigVAT",
    value: function () {
      var _fetchConfigVAT = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee15() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee15$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return _configuration.configurationApi.findParam({
                param: _enum.ConfigurationParam.VatFactor
              });
            case 2:
              res = _context17.sent;
              this.configVAT = res.data;
            case 4:
            case "end":
              return _context17.stop();
          }
        }, _callee15, this);
      }));
      function fetchConfigVAT() {
        return _fetchConfigVAT.apply(this, arguments);
      }
      return fetchConfigVAT;
    }()
  }, {
    key: "fetchOrder",
    value: function () {
      var _fetchOrder = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee16() {
        var _res$data$depositOrde, _res$data$shopeeOrder2, _res$data$shopifyOrde;
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee16$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _context18.next = 2;
              return _order.orderApi.findOne(this.form.id);
            case 2:
              res = _context18.sent;
              this.createdAt = res.data.createdAt * 1000;
              this.orderDetails = res.data.orderDetails.map(function (e) {
                var _e$depositOrderDetail;
                return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, e), {}, {
                  id: e.product.id,
                  productGalleries: e.product.productGalleries,
                  name: e.product.name,
                  detailId: e.id,
                  tabDiscount: e.discountPercent ? "percent" : "price",
                  discountInput: e.discountPercent || e.discountAmount,
                  depositOrderDetailId: (_e$depositOrderDetail = e.depositOrderDetail) === null || _e$depositOrderDetail === void 0 ? void 0 : _e$depositOrderDetail.id,
                  maxQuantity: res.data.type == _order2.OrderType.Consign && e.depositOrderDetail ? e.quantity + e.depositOrderDetail.quantity - e.depositOrderDetail.sold : undefined
                });
              });
              this.form = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, res.data), {}, {
                remindDate: res.data.remindDate * 1000 || 0,
                createdAt: res.data.createdAt * 1000,
                products: this.orderDetails,
                addressCityId: res.data.addressCity.id,
                addressDistrictId: res.data.addressDistrict.id,
                addressWardId: res.data.addressWard.id,
                customerId: res.data.customer ? res.data.customer.id : 0,
                staffId: res.data.staff && res.data.staff.id,
                saleChannelId: res.data.saleChannel && res.data.saleChannel.id,
                skinStatusIds: res.data.customer && res.data.customer.skinStatuses && res.data.customer.skinStatuses.map(function (e) {
                  return e.id;
                }),
                shippingCharge: res.data.orderProgress.shippingChargeByShiratori || res.data.orderProgress.shippingChargeByCustomer,
                customerRank: res.data.customer && res.data.customer.customerRank,
                depositOrderId: (_res$data$depositOrde = res.data.depositOrder) === null || _res$data$depositOrde === void 0 ? void 0 : _res$data$depositOrde.id,
                shopeeOrderId: (_res$data$shopeeOrder2 = res.data.shopeeOrder) === null || _res$data$shopeeOrder2 === void 0 ? void 0 : _res$data$shopeeOrder2.id,
                shopifyOrderId: (_res$data$shopifyOrde = res.data.shopifyOrder) === null || _res$data$shopifyOrde === void 0 ? void 0 : _res$data$shopifyOrde.id
              });
              this.orderProgress = res.data.orderProgress;
            case 7:
            case "end":
              return _context18.stop();
          }
        }, _callee16, this);
      }));
      function fetchOrder() {
        return _fetchOrder.apply(this, arguments);
      }
      return fetchOrder;
    }()
  }, {
    key: "fetchDetailCustomer",
    value: function () {
      var _fetchDetailCustomer = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee17() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee17$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              if (this.form.customerId) {
                _context19.next = 2;
                break;
              }
              return _context19.abrupt("return", false);
            case 2:
              _context19.next = 4;
              return _customer.customerApi.findOne(this.form.customerId);
            case 4:
              res = _context19.sent;
              this.$set(this.form, "detailCustomer", res.data);
            case 6:
            case "end":
              return _context19.stop();
          }
        }, _callee17, this);
      }));
      function fetchDetailCustomer() {
        return _fetchDetailCustomer.apply(this, arguments);
      }
      return fetchDetailCustomer;
    }()
  }, {
    key: "handleUpdate",
    value: function () {
      var _handleUpdate = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee18(data, type) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee18$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              this.form = (0, _objectSpread2.default)({}, data);
              this.shopType = type;
              this.type = data.type;
              this.orderStatus = data.orderStatus;
              this.fetchConfigVAT();
              _context20.next = 7;
              return this.fetchOrder();
            case 7:
              this.fetchDetailCustomer();
              this.visible = true;
              this.status = "update";
            case 10:
            case "end":
              return _context20.stop();
          }
        }, _callee18, this);
      }));
      function handleUpdate(_x5, _x6) {
        return _handleUpdate.apply(this, arguments);
      }
      return handleUpdate;
    }()
  }, {
    key: "handleView",
    value: function () {
      var _handleView = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee19(currentOrder, previousOrder) {
        var current, previous;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee19$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              this.compareOrder = {};
              _context21.next = 3;
              return this.fetchViewOrder(currentOrder);
            case 3:
              current = _context21.sent;
              if ((0, _lodash.isEmpty)(previousOrder)) {
                _context21.next = 9;
                break;
              }
              _context21.next = 7;
              return this.fetchViewOrder(previousOrder);
            case 7:
              previous = _context21.sent;
              this.checkDiff(current, previous);
            case 9:
              this.createdAt = current.createdAt;
              this.form = (0, _objectSpread2.default)({}, current);
              this.orderProgress = current.orderProgress;
              this.visible = true;
              this.status = "update";
              this.type = currentOrder.type;
              this.orderStatus = currentOrder.orderStatus;
            case 16:
            case "end":
              return _context21.stop();
          }
        }, _callee19, this);
      }));
      function handleView(_x7, _x8) {
        return _handleView.apply(this, arguments);
      }
      return handleView;
    }()
  }, {
    key: "checkDiff",
    value: function checkDiff(currentOrder, oldOrder) {
      var _this4 = this;
      var compareOrder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.compareOrder;
      Object.entries(currentOrder).forEach(function (e) {
        var prop = e === null || e === void 0 ? void 0 : e[0];
        var value = e === null || e === void 0 ? void 0 : e[1];
        var oldOrderValue = oldOrder[prop];
        if ((0, _validate.isArray)(value) && (0, _validate.isArray)(oldOrderValue) && value.length != oldOrderValue.length) {
          compareOrder[prop + "Length"] = true;
        }
        if ((0, _lodash.isObject)(value) && !(0, _lodash.isEmpty)(value) && !(0, _validate.isArray)(value) && !(0, _lodash.isEmpty)(oldOrderValue)) {
          compareOrder[prop] = {};
          _this4.checkDiff(value, oldOrderValue, compareOrder[prop]);
          return;
        }
        if ((0, _validate.isArray)(value)) {
          compareOrder[prop] = [];
          for (var i = 0; i < value.length; i++) {
            compareOrder[prop].push({});
            if (oldOrderValue && oldOrderValue[i]) {
              var valueCurrentOrderArray = value[i];
              var valueOldOrderArray = oldOrderValue[i];
              _this4.checkDiff(valueCurrentOrderArray, valueOldOrderArray, compareOrder[prop][i]);
            }
          }
          return;
        }
        if ((!(0, _lodash.isNil)(oldOrderValue) || !(0, _lodash.isNil)(value)) && !(0, _lodash.isEqual)(oldOrderValue, value)) {
          compareOrder[prop] = true;
        }
      });
    }
  }, {
    key: "fetchViewOrder",
    value: function () {
      var _fetchViewOrder = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee20(order) {
        var _order$depositOrder;
        var currentOrder, resCustomer;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee20$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              currentOrder = {};
              currentOrder = (0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, currentOrder), order), {}, {
                remindDate: order.remindDate * 1000 || 0,
                createdAt: order.createdAt * 1000,
                products: order.orderDetails.map(function (e) {
                  var _e$depositOrderDetail2, _e$depositOrderDetail3, _e$depositOrderDetail4;
                  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, e), {}, {
                    id: e.product && e.product.id,
                    productGalleries: e.product.productGalleries,
                    name: e.product.name,
                    detailId: e.id,
                    tabDiscount: e.discountPercent ? "percent" : "price",
                    discountInput: e.discountPercent || e.discountAmount,
                    depositOrderDetailId: (_e$depositOrderDetail2 = e.depositOrderDetail) === null || _e$depositOrderDetail2 === void 0 ? void 0 : _e$depositOrderDetail2.id,
                    maxQuantity: order.type == _order2.OrderType.Consign && e.depositOrderDetail ? e.quantity + ((_e$depositOrderDetail3 = e.depositOrderDetail) === null || _e$depositOrderDetail3 === void 0 ? void 0 : _e$depositOrderDetail3.quantity) - ((_e$depositOrderDetail4 = e.depositOrderDetail) === null || _e$depositOrderDetail4 === void 0 ? void 0 : _e$depositOrderDetail4.sold) : undefined
                  });
                }),
                addressCityId: order.addressCity && order.addressCity.id,
                addressDistrictId: order.addressDistrict && order.addressDistrict.id,
                addressWardId: order.addressWard && order.addressWard.id,
                customerId: order.customer ? order.customer.id : 0,
                staffId: order.staff && order.staff.id,
                saleChannelId: order.saleChannel && order.saleChannel.id,
                skinStatusIds: order.customer && order.customer.skinStatuses && order.customer.skinStatuses.map(function (e) {
                  return e.id;
                }),
                shippingCharge: order.orderProgress.shippingChargeByShiratori || order.orderProgress.shippingChargeByCustomer,
                customerRank: order.customer && order.customer.customerRank,
                depositOrderId: (_order$depositOrder = order.depositOrder) === null || _order$depositOrder === void 0 ? void 0 : _order$depositOrder.id
              });
              currentOrder.orderProgress = order.orderProgress;
              if (!currentOrder.customerId) {
                _context22.next = 8;
                break;
              }
              _context22.next = 6;
              return _customer.customerApi.findOne(currentOrder.customerId);
            case 6:
              resCustomer = _context22.sent;
              currentOrder.detailCustomer = resCustomer.data;
            case 8:
              return _context22.abrupt("return", currentOrder);
            case 9:
            case "end":
              return _context22.stop();
          }
        }, _callee20);
      }));
      function fetchViewOrder(_x9) {
        return _fetchViewOrder.apply(this, arguments);
      }
      return fetchViewOrder;
    }()
  }, {
    key: "handleCheckPublish",
    value: function handleCheckPublish(deliveryFeeType) {
      this.orderProgress = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.orderProgress), {}, {
        deliveryFeeType: deliveryFeeType
      });
    }
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], OrderModal.prototype, "disabled", void 0);
OrderModal = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    ProductOrderForm: _ProductOrderForm.default,
    CustomerOrderForm: _CustomerOrderForm.default,
    OrderInfoForm: _OrderInfoForm.default,
    PackageOrderForm: _PackageOrderForm.default,
    PaymentOrderForm: _PaymentOrderForm.default,
    ReceiptPrint: _ReceiptPrint.default,
    AddPickupAddressModal: _AddPickupAddressModal.default,
    ModifyHistoryModal: _ModifyHistoryModal.default,
    PrintInformationForm: _PrintInformationForm.default,
    CustomerDialog: function CustomerDialog() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require("@/views/customer/components/CustomerDialog.vue"));
      });
    }
  }
})], OrderModal);
var _default = exports.default = OrderModal;